var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo01"},[_c('div',{staticClass:"content"},[_c('ul',{class:{marquee_top:_vm.animate}},_vm._l((_vm.lists),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item))])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }